"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTextArea = _interopRequireDefault(require("./CwTextArea.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var CwTextArea =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CwTextArea, _Component);

  function CwTextArea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwTextArea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwTextArea).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (e) {
      if (!_this.props.onChange) {
        return;
      }

      _this.props.onChange(e.target.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyPress", function (e) {
      if (_this.props.isDisabled || !_this.props.onKeyPress) {
        return;
      }

      _this.props.onKeyPress(e);
    });
    _this.textarea = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(CwTextArea, [{
    key: "focus",
    value: function focus() {
      this.textarea.current.focus();
    }
  }, {
    key: "setSelectionRange",
    value: function setSelectionRange(selectionStart, selectionEnd) {
      this.textarea.current.setSelectionRange(selectionStart, selectionEnd);
    }
  }, {
    key: "render",
    value: function render() {
      var styles = {
        wrap: _objectSpread({
          height: this.props.height,
          minHeight: this.props.minHeight,
          maxHeight: this.props.maxHeight,
          width: this.props.width
        }, this.props.style)
      };
      return _react.default.createElement("textarea", {
        "data-cwid": this.props.cwId,
        "data-cwdata": "focusable",
        style: styles.wrap,
        className: (0, _classnames.default)(this.props.className, this.props.invalid ? _CwTextArea.default.textAreaInvalid : _CwTextArea.default.textArea),
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly,
        value: this.props.value ? this.props.value : '',
        onChange: this.handleChange,
        onKeyDown: this.props.onKeyDown,
        onClick: this.props.onClick,
        onKeyUp: this.props.onKeyUp,
        onKeyPress: this.handleKeyPress,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex,
        disabled: this.props.disabled,
        maxLength: this.props.maxLength,
        ref: this.textarea,
        autoFocus: this.props.autoFocus,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur
      });
    }
  }]);
  return CwTextArea;
}(_react.Component);

exports.default = CwTextArea;
CwTextArea.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Text in textfield
   */
  value: _propTypes.default.string,

  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes.default.string,

  /**
   * Used to set text area to a read only mode
   */
  readOnly: _propTypes.default.bool,

  /**
   * Callback function that is fired when textarea's text changes
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function that is fired when key is pressed while textarea is active
   */
  onKeyPress: _propTypes.default.func,

  /**
   * Height for textarea
   */
  height: _propTypes.default.number,

  /**
   * Min Height for textarea
   */
  minHeight: _propTypes.default.number,

  /**
   * Max Height for textarea
   */
  maxHeight: _propTypes.default.number,

  /**
   * The maximium number of characters allowed in the field.
   */
  maxLength: _propTypes.default.number,

  /**
   * Width for textarea
   */
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Used to control order when tabbing through items
   */
  tabIndex: _propTypes.default.number,

  /**
   * Used to control if text is valid
   */
  invalid: _propTypes.default.bool,

  /**
   * Used to disable textarea
   */
  disabled: _propTypes.default.bool,

  /**
   * Used to control if textarea is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string
};
CwTextArea.defaultProps = {
  tabIndex: 0
};